import dynamicTagHelper from 'ub/data/dtr-tag-helper.js';

function _selectDomNode(element) {
    let range;
    let selection;

    if (window.getSelection) {
        selection = window.getSelection();
        range = document.createRange();
        range.selectNode(element);
        selection.removeAllRanges();
        selection.addRange(range);
    }
}

export function selectDynamicTag($selectedElement) {
  const dynamicTagName = dynamicTagHelper.getDynamicTagQueryName(window.editor);
  const $nearestDynamicTag = $selectedElement.closest(dynamicTagName);

  if ($nearestDynamicTag.length > 0) {
    const domNode = $nearestDynamicTag[0];
    _selectDomNode(domNode);
  }
}



// WEBPACK FOOTER //
// ./src/ui/inline-text/utils/dtr-selection-manager.js